import "../../components/App.css";
import React, { useState, useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import GadgetCarePlan from "./GadgetCarePlan";
import AutoCarePlan from "./AutoCarePlan";
import FurnitureCarePlan from "./FurnitureCarePlan";
import TravelCarePlan from "./TravelCarePlan";
import EventsCarePlan from "./EventsCarePlan";
import AgricultureCarePlan from "./AgricultureCarePlan";
import ManufacturingCarePlan from "./ManufacturingCarePlan";
import Logo from "../../assets/logo.jpg";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_BASE_URL } from "../../config/config";

const CarePlan = () => {
  const [category, setCategory] = useState("Gadgets");
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenValidity = async () => {
      try {
        const token = localStorage.getItem('care_token');
        if (!token) {
          navigate('/login');
        } else {
          const tokenData = jwtDecode(token);
          const currentTime = new Date().getTime();
          if (currentTime > tokenData.expiry) {
            localStorage.removeItem('care_token');
            navigate('/login');
          } else {
            const userId = tokenData.userId;
  
            const response = await axios.get(`${API_BASE_URL}/user?userId=${userId}`, {
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
  
            setUserDetails(response.data.user);
            setLoading(false);
          }
        }
      } catch (error) {
        console.error('Error:', error);
        localStorage.removeItem('care_token');
        navigate('/login');
      }
    };
  
    checkTokenValidity();  
  }, [navigate]);

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  return (
    <div className="registration-form-container">
      <div className="registration-form">
      <img src={Logo} alt="Logo" width={60} className="form-logo" />
      <Typography variant="h4" align="center" gutterBottom>
          Bevogtet Care CarePlan
        </Typography>
        <div className="category-selector">
          <FormControl component="fieldset">
            <RadioGroup
              row
              aria-label="category"
              name="category"
              value={category}
              onChange={handleCategoryChange}
            >
              <FormControlLabel
                value="Gadgets"
                control={<Radio color="primary" />}
                label="Gadgets"
              />
              <FormControlLabel
                value="Auto"
                control={<Radio color="primary" />}
                label="Auto"
              />
              <FormControlLabel
                value="Furniture"
                control={<Radio color="primary" />}
                label="Furniture"
              />
              <FormControlLabel
                value="Travel"
                control={<Radio color="primary" />}
                label="Travel"
              />
              <FormControlLabel
                value="Events"
                control={<Radio color="primary" />}
                label="Events"
              />
              <FormControlLabel
                value="Agriculture"
                control={<Radio color="primary" />}
                label="Agriculture"
              />
              <FormControlLabel
                value="Manufacturing & Goods"
                control={<Radio color="primary" />}
                label="Manufacturing & Goods"
              />
            </RadioGroup>
          </FormControl>
        </div>
        {category === "Gadgets" && <GadgetCarePlan userDetails={userDetails} />}
        {category === "Auto" && <AutoCarePlan userDetails={userDetails} />}
        {category === "Furniture" && <FurnitureCarePlan userDetails={userDetails} />}
        {category === "Travel" && <TravelCarePlan userDetails={userDetails} />}
        {category === "Events" && <EventsCarePlan userDetails={userDetails} />}
        {category === "Agriculture" && <AgricultureCarePlan userDetails={userDetails} />}
        {category === "Manufacturing & Goods" && (
          <ManufacturingCarePlan userDetails={userDetails} />
        )}
      </div>
    </div>
  );
};

export default CarePlan;
